import { useEffect, useRef } from 'react'

import { useAppDispatch } from 'common/hooks/redux'

import { teamChatApi } from 'features/TeamChat/api/teamChat.api'

const FORBIDDEN = 403

// A 403 after mount means access was revoked: dropping the cache refetches members, whose 403 turns the widget and socket off.
export const useRevokeOnForbidden = (error: unknown): void => {
  const dispatch = useAppDispatch()
  // Once per mount, so a server that keeps the roster but refuses the summary cannot loop.
  const revoked = useRef(false)

  useEffect(() => {
    if (revoked.current || (error as { status?: unknown } | undefined)?.status !== FORBIDDEN) return
    revoked.current = true
    dispatch(teamChatApi.util.resetApiState())
  }, [error, dispatch])
}
